//Get React and the hook
import React, {useState} from 'react'

const Accordion = ({items}) => {
    const [activeIndex, setActiveIndex] = useState(null);

    //Helper function when title clicked (clicking the open one closes it)
    const onTitleClick = (index) =>  {
        setActiveIndex(index === activeIndex ? null : index);
    }

    const renderedItems = items.map((item, index) => {
        //Changing the css based on index
        const active = index === activeIndex ? 'active' : '';

        return(
        //React Fragment makes it so there is no extra element it is just contained with that extra info
        <React.Fragment key={item.title}>
            <button
                className={"accordion-title " + active}
                onClick={() => onTitleClick(index)}
            >
                <span className="chevron">&#9656;</span>
                {item.title}
            </button>
            <div className={"accordion-content " + active}>
                <p>{item.content}</p>
            </div>
        </React.Fragment>
        );
    });
    return <div className="accordion">
        {renderedItems}
    </div>
};

export default Accordion;
